import React from 'react';
import { FileUploader } from 'shared/FileUploader/FileUploader';
import { MainTemplate } from 'shared/MainTemplate/MainTemplate';
// import './MediaPage.sass';

export const MediaPage: React.FC = () => {
	return <FileUploader text='Добавить файлы' staticPosition open />;
};
